module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_7042.0f14c48c.png";